/**
 * Підписи полів клієнта — одне джерело для ресурсу, картки, історії змін і
 * помилок 422 (`SPEC-009` §3.2, §8.7). Тексти — дослівно з легасі
 * (`frontend/src/Ship/Locales/uk/translation.json`), крім виправлених D-23.
 *
 * ⚠️ Бек пише ті самі підписи в `payload` події `client_updated`
 * (`ClientHistoryService`, `SPEC-009` §4.9). Розійдуться — стрічка історії
 * назве поле не так, як картка поруч.
 */
export const CLIENT_FIELD_LABELS = {
    id: 'Ід',
    title: 'Назва',
    fullName: 'Повна назва',
    status: 'Статус',
    responsibles: 'Відповідальний',
    emails: 'Пошта',
    phones: 'Телефони',
    tags: 'Теги',
    comment: 'Коментар',
    formTaxation: 'Форма оподаткування',
    address: 'Адреса',
    iban: 'Рахунок IBAN',
    bank: 'Банк рахунку',
    mfo: 'МФО банку рахунку',
    edrpou: 'Код ЄДРПОУ',
    numberVAT: 'Номер витягу платника ПДВ',
    ipn: 'ІПН',
    manager: 'ПІБ директора',
    forwarder: 'Експедитор клієнта',
    contactPerson: 'Контактна особа',
    positionContactPerson: 'Посада контактної особи',
    contactPersonPhone: 'Телефон контактної особи',
    contactPersonEmail: 'Пошта контактної особи',
    typeCargo: 'Тип вантажу',
    approximateCostCargo: 'Орієнтовна вартість вантажу',
    routeFirstShipment: 'Маршрут першого перевезення',
    costFirstShipmentClient: 'Вартість першого перевезення на клієнта',
    costFirstShipmentCarrier: 'Вартість першого перевезення на перевізника',
    clientPaymentTerm: 'Термін оплати клієнта',
    verifiedBy: 'Ким верифіковано',
    verifiedAt: 'Дата та час верифікації',
    commentVerification: 'Коментар до верифікації',
    createdAt: 'Дата створення',
    createdBy: 'Хто створив',
    updatedAt: 'Дата зміни',
    updatedBy: 'Хто змінив',
} as const

export type ClientFieldName = keyof typeof CLIENT_FIELD_LABELS

/**
 * Пари «сума + валюта» (`SPEC-008` §4.8): у картці — одне поле
 * `CostCurrencyField`, у формі створення валюта за замовчуванням — EUR (КЛ-08).
 */
export const CLIENT_COST_FIELDS = [
    { amount: 'approximateCostCargo', currency: 'approximateCostCargoCurrency' },
    { amount: 'costFirstShipmentClient', currency: 'costFirstShipmentClientCurrency' },
    { amount: 'costFirstShipmentCarrier', currency: 'costFirstShipmentCarrierCurrency' },
] as const
